import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'The transfer has not been executed.\n{employeeName} will be notified by e-mail of the rejection of their request.',
    heading: 'The transfer request has been rejected',
  },
  fr: {
    description:
      'Le virement n’a pas été exécuté.\n{employeeName} sera notifié·e par e-mail du refus de sa demande.',
    heading: 'La demande de virement a été rejetée',
  },
} as const);

export default locales;
